import { useState } from "react";
import { Button, MenuItem, Select, TextareaAutosize } from "@mui/material";
import { SendIcon } from "@100mslive/react-icons";
import { AI_MODELS_LIST } from "../../common/constants";

const AIChatEditor = props => {
  const { loading, query, setQuery, model, setModel, sending, sendQuery } =
    props;
  const [enableAutoFocus, setEnableAutoFocus] = useState(false);
  return (
    <div className="events-page-aichat-content-editor">
      {sending ? (
        <div className="events-page-aichat-content-editor-loading">
          AI is thinking...
        </div>
      ) : (
        <>
          <TextareaAutosize
            autoFocus={enableAutoFocus}
            tabIndex={-1}
            maxRows={2}
            minRows={2}
            className="events-page-aichat-content-editor-input"
            placeholder="Ask about any stock, sector, or investment strategy..."
            value={query}
            readOnly={loading}
            disabled={loading}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendQuery();
                setEnableAutoFocus(true);
              }
            }}
          />
          <div className="events-page-aichat-content-editor-action">
            <div className="events-page-aichat-content-editor-action-right">
              <Select
                className="custom-select custom-select-secondary"
                sx={{
                  height: "36px",
                  background: "transparent !important",
                }}
                value={model}
                onChange={e => {
                  setModel(e.target.value);
                }}
                displayEmpty
              >
                {Object.keys(AI_MODELS_LIST)?.map((ml, index) => (
                  <MenuItem key={index} value={ml}>
                    {AI_MODELS_LIST?.[ml]?.label}
                    <small className="text-secondary ml-auto">
                      &nbsp; &nbsp; {AI_MODELS_LIST?.[ml]?.type}
                    </small>
                  </MenuItem>
                ))}
              </Select>

              <Button
                tabIndex={-1}
                onClick={() => {
                  sendQuery();
                  setEnableAutoFocus(true);
                }}
                color="primary"
                variant="outlined"
                size="small"
                sx={{ minWidth: "none" }}
                className="events6ix-btn events6ix-btn-sm events6ix-btn-secondary events-page-aichat-content-editor-action-btn"
              >
                <SendIcon />
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AIChatEditor;
